import { useTranslation } from 'react-i18next';

interface TimelineSectionHeaderProps {
  groupKey: string;
  label: string;
  color?: string;
  count: number;
}

/** Read-only section header (status/priority/group bucket) — no collapse/rename, unlike List's `SectionGroup`. */
export function TimelineSectionHeader({
  groupKey,
  label,
  color,
  count,
}: TimelineSectionHeaderProps) {
  const { t } = useTranslation('tasks');

  return (
    <div
      data-testid={`tasks-timeline-section-header-${groupKey}`}
      className="border-b border-border bg-muted/30"
    >
      <div className="sticky left-0 z-10 flex w-fit items-center gap-2 px-6 py-2">
        {color && (
          <span
            className="size-2 shrink-0 rounded-full"
            style={{ background: color }}
            aria-hidden
          />
        )}
        <span className="text-xs font-semibold uppercase text-foreground/80">{label}</span>
        <span className="text-xs text-muted-foreground">
          · {t('timeline.section.taskCount', { count })}
        </span>
      </div>
    </div>
  );
}
